import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';

import RowView from './RowView';
import BaseText from './BaseText';
import { Color } from '../styles';
import { scale, scaleVertically } from '../utils/scale.utils';

const BottomSheetOption = ({ label, onPress }) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <View style={styles.hrLine} />
      <RowView style={styles.rowView}>
        <BaseText style={styles.optionButtonTextStyle}>{label}</BaseText>
      </RowView>
    </TouchableOpacity>
  );
};

export const styles = StyleSheet.create({
  rowView: { justifyContent: 'center' },
  optionButtonTextStyle: { fontSize: scale(20), margin: scaleVertically(7) },
  hrLine: {
    borderBottomColor: Color.gray,
    borderBottomWidth: 1,
    marginBottom: scaleVertically(7),
  },
});

export default BottomSheetOption;
